import { jsx as t } from "react/jsx-runtime";
const p = ({ children: s, searchTerm: n }) => {
  if (!n)
    return /* @__PURE__ */ t("span", { children: s });
  const r = n.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&").split(/\s+/).filter((e) => e.length > 1), o = `(${r.join("|")})`, c = s.split(new RegExp(o, "gi"));
  return /* @__PURE__ */ t("span", { children: c.map((e, a) => r.some(
    (i) => e.toLowerCase() === i.toLowerCase()
  ) ? /* @__PURE__ */ t("mark", { className: "bg-accent text-accent-foreground", children: e }, a) : /* @__PURE__ */ t("span", { children: e }, a)) });
};
export {
  p as default
};
